import styled from 'styled-components';
import {
  BREAKPOINT,
  REBRAND_COLOR,
  PADDING,
  REBRAND_SHADOW,
  REBRAND_GRADIENT
} from '@latitude/core/utils/constants';
import Section from '@latitude/section-rebrand';

export const Wrapper = styled.div`
  background-color: ${REBRAND_COLOR.STONE};
`;

export const StyledCardFilterContainer = styled(Section)`
  display: flex;
  flex-direction: column;
  gap 16px;
  padding-top: ${PADDING.P32};
  align-items: center;
  background-color: ${REBRAND_COLOR.STONE};
  padding-bottom: ${PADDING.P32};
  @media (min-width: ${BREAKPOINT.LG}) {
    padding-top: ${PADDING.P64};
    gap: 48px;
  }
`;

export const StyledContentContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  @media (min-width: ${BREAKPOINT.LG}) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: ${BREAKPOINT.XL}) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const StyledCard = styled.div`
  border-radius: 16px;
  background: linear-gradient(180deg, #91D0FF 0%, #C3E5FF 50%, #EFF8FF 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: ${REBRAND_SHADOW.MEDIUM};
`;

export const StyledTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  flex: 1;
  width: 100%;
  padding: ${PADDING.P64} ${PADDING.P24} ${PADDING.P32} ${PADDING.P24};
  @media (min-width: ${BREAKPOINT.LG}) {
    padding: ${PADDING.P64} ${PADDING.P24};
  }
  .typography-base__sh1 {
    text-align: center;
  }
`;

export const StyledStatsRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-height: 88.5px;
  @media (min-width: ${BREAKPOINT.LG}) {
    flex-direction: row;
    gap: 40px;
  }
`;

export const StyledStatBox = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
`;

export const StyledDescriptionList = styled.ul`
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  margin-bottom: 64px;
`;

export const StyledActions = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;
  margin-top: auto;
`;

export const StyledImageContainer = styled.div`
  position: relative;
  width: 100%;
  overflow: visible;

`;

export const StyledBgImage = styled.img`
  width: 100%;
  height: auto;
  object-fit: contain;
  display: block;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  transform: ${({ productid }) =>
      productid === 'CCAUDJ' ? `scaleX(-1);` : `scaleX(1);`};
`;

export const StyledCardArtImage = styled.img`
  position: absolute;
  left: ${({ productid }) =>
      productid === 'CCAUDJ' ? `80%` : `88%`};
  bottom: 0;
  transform: translateX(-50%) translateY(30px);
  width: ${({ productid }) =>
      productid === 'CCAUDJ' ? `calc(100% / 2.5)` : `calc(100% / 6)`};
  height: auto;
`;

export const StyledFilterContainer = styled.div`
  @media (max-width: ${BREAKPOINT.LG}) {
    width: 100%;
  }
`;

export const StyledSubHeading = styled.div`
  text-align: center;
`;

export const StyledHeader = styled.div`
`;
